import React, { useEffect, useState } from 'react'
import { fetchGeneralPaymentDetails, getCourses } from '../../../firebase/utils'
import { Table } from 'antd'
import moment from 'moment'
import { Breadcrumbs, Btn } from '../../../AbstractElements'
import { Card, Container } from 'reactstrap'
import SeachBar from '../../UiKits/SearchBar'
import CourseAction from './CourseAction'
import CourseModal from './CourseModal'

const CoursesManagement = () => {
  const [courses, setCourses] = useState([])
  const [loading, setLoading] = useState('')
  const [PaymentDetails, setPaymentDetails] = useState('')
  const [modal, setModal] = useState({
    show: false,
    type: "",
    data: null
  })
  const [search, setSearch] = useState('');
  const [sortColumn, setSortColumn] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');

  const fetchCourses = async () => {
    const allcourses = await getCourses();
    setCourses(allcourses)
  }

  const getData = async () => {
    const payment = await fetchGeneralPaymentDetails()
    setPaymentDetails(payment.paymentDetails)
    setLoading(false)
  }

  const showModal = (type, data) => {
    setModal({
      show: true,
      type,
      data
    })
  }

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  const sortedCourses = [...courses].sort((a, b) => {
    let valueA = a[sortColumn];
    let valueB = b[sortColumn];
    
    if (typeof valueA === 'string') valueA = valueA.toLowerCase();
    if (typeof valueB === 'string') valueB = valueB.toLowerCase();
    
    if (sortColumn.includes('Date')) {
      return sortDirection === 'asc'
        ? new Date(valueA) - new Date(valueB)
        : new Date(valueB) - new Date(valueA);
    }
    
    return sortDirection === 'asc' ? (valueA > valueB ? 1 : -1) : (valueA < valueB ? 1 : -1);
  });



  const courseTableColumnRow = [
    {
      title: "Course Name",
      dataIndex: "name",

      sorter: () => handleSort('name'),
    },
    {
      title: "Type",
      dataIndex: "type",
      sorter: () => handleSort('type'),
    },
    {
      title: "Seats Full",
      dataIndex: "seatsFull",
      render: (seatsFull) => seatsFull ? 'Yes' : 'No',
      sorter: () => handleSort('seatsFull'),
    },
    {
      title: "Current Course",
      dataIndex: "isCurrent",
      render: (isCurrent) => (isCurrent ? 'Yes' : 'No'),
      sorter: () => handleSort('isCurrent'),
    },
    {
      title: "Admission Open",
      dataIndex: "admissionOpen",
      render: (admissionOpen) => (admissionOpen ? 'Yes' : 'No'),
      sorter: () => handleSort('admissionOpen'),
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      render: (startDate) => moment(startDate).format('L'),
      sorter: () => handleSort('startDate'),
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      render: (endDate) => moment(endDate).format('L'),
      sorter: () => handleSort('endDate'),
    },
    {
      title: "Actions",
      render: (data) => <CourseAction courses={courses} setCourses={setCourses} data={data} showModal={showModal} />,
    },
  ]

  const filteredCourses = sortedCourses.filter(course => course.name.toLowerCase().includes(search.toLowerCase()))

  useEffect(() => {
    getData()
    fetchCourses()
  }, [])
  return (
    <div>
      <Breadcrumbs mainTitle={'Course Management'} />
      <Container fluid={true} className="dashboard-default">
        <Card className='p-3'>
          <div className='bug-report-search course-page'>
            <SeachBar search={search} setSearch={setSearch} />
            <div className='course-table-action'>
              <Btn attrBtn={{ color: "primary", onClick: () => showModal('CREATE_COURSE') }}>Create Course</Btn>
              <Btn attrBtn={{ color: "secondary", onClick: () => showModal('GENERAL_PAYMENT', PaymentDetails) }}>Edit General Payment Detail</Btn>
            </div>
          </div>
          <div className='m-b-50 ant-design-table not-margin'>
            <Table rowClassName={(record) => record ? 'table-row-text' : ''}
              columns={courseTableColumnRow} loading={loading} dataSource={filteredCourses} scroll={{ x: "auto" }}
            />
          </div>
        </Card>
      </Container>
      {modal.show && <CourseModal fetchGeneralPayment={getData} courses={courses} data={modal.data} modal={modal} fetchCourses={fetchCourses} setModal={setModal} />}

    </div>
  )
}

export default CoursesManagement
